import React from "react"
import { signOut } from "aws-amplify/auth"
import PageHeader from "components/Ui/Page/PageHeader"
import { ReactComponent as LogoutIcon } from "images/icons/arrow-right-from-bracket.svg"
import { useSelector } from "react-redux"
import { selectUserAttributes, selectUserGroups } from "lib/store/services/auth/selectors"
import { Break, Container, Group, Info, Label, SignOutButton } from "./User.styled"

export const User = () => {
  const userAttributes = useSelector(selectUserAttributes)
  const userGroups = useSelector(selectUserGroups)
  const logout = () => {
    signOut().then(() => window.location.reload())
  }

  const legacyGroups: Record<string, string> = {
    ["brinkcommerce-superuser"]:
      "Administer access, you can create and edit configurations, manage discount rules, and perform other related tasks.",
    ["brinkcommerce-readonly"]:
      "Read-only access to Merchant Portal, which means you can view discounts, orders, configurations, etc.",
    ["brinkcommerce-useradmin"]: "Administer users and API clients in Merchant Portal",
    ["brinkcommerce-campaignuser"]: "View, create and edit campaign groups and campaigns"
  }

  const allowedGroups: Record<string, string> = {
    ["cx-user"]: "View order information and initiate actions such as cancellations, refunds etc.",
    ["cx-admin"]:
      "View order information and initiate and start actions such as cancellations, refunds etc.",
    ["ecom-user"]: "View discounts and campaigns.",
    ["ecom-admin"]: "View, create and edit discounts and campaigns.",
    ["system-user"]:
      "View system-wide configuration such as inventories, stores, API clients, users etc.",
    ["system-admin"]:
      "Administer system-wide configuration such as inventories, stores, API clients, users etc.",
    ...legacyGroups
  }

  return (
    <>
      <PageHeader title="Merchant Portal user">
        <SignOutButton handleClick={logout}>
          <LogoutIcon />
          <span className="hideOnSmallScreens">Sign out</span>
        </SignOutButton>
      </PageHeader>
      <Container>
        <Info>
          <Label>Given name</Label>
          <div>{userAttributes?.given_name}</div>
          <Break />
          <Label>Family name</Label>
          <div>{userAttributes?.family_name}</div>
          <Break />
          <Label>Username (email)</Label>
          <div>{userAttributes?.email}</div>
          <Break />
        </Info>
        <Info>
          <Label>Access</Label>
          <div>
            {userGroups?.filter((group: string) => allowedGroups?.[group] ?? undefined).length >
            0 ? (
              userGroups
                ?.filter((group: string) => allowedGroups?.[group] ?? undefined)
                .map((group: string) => (
                  <Group key={group}>
                    <span>{group}</span> <div>{allowedGroups?.[group] ?? undefined}</div>
                  </Group>
                ))
            ) : (
              <div>No group connected to user</div>
            )}
          </div>
        </Info>
      </Container>
    </>
  )
}
